export function getStatus(state) {
  return state === 'NO_SHOW' ? 'No show - Unscheduled' : 'Unscheduled'
}
